// extracted by mini-css-extract-plugin
export default {"wrapper":"EmptyInsights_wrapper__Vvi8T"};